import { render } from "./TransactionStatus.vue?vue&type=template&id=99fa57bc&scoped=true"
import script from "./TransactionStatus.vue?vue&type=script&lang=js"
export * from "./TransactionStatus.vue?vue&type=script&lang=js"

import "./TransactionStatus.vue?vue&type=style&index=0&id=99fa57bc&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99fa57bc"]])

export default __exports__